import { Flags } from '@ai-platform/utils';
import { createContext, FC, useContext } from 'react';

export const ExperimentsContext = createContext<{ flags: Partial<Flags> }>({
    flags: {},
});

type Props = {
    children: React.ReactNode;
};

export const ExperimentsProvider: FC<Props> = ({ children }) => {
    const flags = typeof window === 'undefined' || window.__APP_DATA__ === undefined ? {} : window.__APP_DATA__?.flags;

    return <ExperimentsContext.Provider value={{ flags }}>{children}</ExperimentsContext.Provider>;
};

export function useExperimentFlag(flagName: keyof Flags) {
    return useContext(ExperimentsContext).flags[flagName];
}
